import React from "react";
import { useAnimatedCounter } from "../hooks/useAnimatedCounter";

const AnimatedNumber = ({
  start,
  end,
  suffix = "",
  prefix = "",
  duration = 2000,
  className = "",
}) => {
  const { ref, value } = useAnimatedCounter({ start, end, duration });

  return (
    <span ref={ref} className={className}>
      {prefix}
      {value}
      {suffix}
    </span>
  );
};

export const AnimatedCountUp = ({ value, suffix = "+", duration = 2000, className }) => (
  <AnimatedNumber
    start={0}
    end={value}
    suffix={suffix}
    duration={duration}
    className={className}
  />
);

export const AnimatedCountDownYear = ({
  endYear = 1992,
  duration = 2200,
  className,
}) => {
  const currentYear = new Date().getFullYear();
  const { ref, value } = useAnimatedCounter({
    start: currentYear,
    end: endYear,
    duration,
  });

  return (
    <span ref={ref} className={className}>
      {value}
    </span>
  );
};

export default AnimatedNumber;
